<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>A slideshow component for cycling through elements—images or slides of text—like a carousel. <em>Nested
  carousels are not supported.</em></p>
  <p>The easiest way to add the carousel component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">carousel</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
